module.exports = "/images/vendor/flag-icon-css/flags/1x1/na.svg?74257fb27e114303ff5cdcc13d7834e2";